import { Arrange, Container, Pill } from '@loomhq/lens';
import React from 'react';

import { CLOUDFRONT_URI } from 'constants/routes';

import ProcessErrorOverlay from './process-error-overlay';

const ThumbSwitch = ({ video, isAnimated }) => {
  const { complete, thumbnails, isUserUploadedVideo } = video;

  const withVideo = Boolean(isAnimated && thumbnails?.['animatedPreview']);
  const withCustomThumbnail = Boolean(thumbnails?.['full']);
  const withThumbnail = Boolean(thumbnails?.['default']);
  // iOS safari won't display anything unless we force it
  // through media fragments.
  // https://www.w3.org/TR/media-frags/
  const imgFor = prop => `${CLOUDFRONT_URI}/${thumbnails?.[prop]}#t=0.1`;

  const loadingOverlay = (
    <Container width="100%">
      <Arrange alignItems="center" height="100%" justifyContent="center">
        <Pill color="white" backgroundColor="grey8">
          {isUserUploadedVideo ? 'Processing…' : 'Uploading…'}
        </Pill>
      </Arrange>
    </Container>
  );

  let thumbnailImage;

  if (withThumbnail) {
    thumbnailImage = <img alt="" src={imgFor('default')} loading="lazy" />;
  }

  if (withVideo) {
    thumbnailImage = (
      <video
        loop={true}
        muted={true}
        playsInline={true}
        src={imgFor('animatedPreview')}
      />
    );
  }

  if (withCustomThumbnail) {
    thumbnailImage = <img alt="" src={imgFor('full')} loading="lazy" />;
  }

  return (
    <>
      {thumbnailImage}
      <ProcessErrorOverlay video={video} />
      {!complete && loadingOverlay}
    </>
  );
};

const PlaceholderVideoThumbnail = ({ video }) => {
  const { isAnimated } = video;

  return <ThumbSwitch isAnimated={isAnimated} video={video} />;
};

export default PlaceholderVideoThumbnail;
